export default __webpack_public_path__ + "static/media/1、首页500 无糖茶.d62a1f55.jpg";